// extracted by mini-css-extract-plugin
module.exports = {"container":"VastTaskChange_container__2lMpX"};